import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchApiKeys } from '@/api/api-keys';
import { useTable } from '@/hooks/useTable';

function buildQs(
  page: number,
  limit: number,
  sort?: unknown,
  filter?: string,
): string {
  const qs = new URLSearchParams();
  qs.set('page', String(Math.max(0, page - 1)));
  qs.set('count', String(limit));
  if (sort) qs.set('sort', String(sort));
  if (filter) qs.set('filter', filter);
  return qs.toString();
}

export function apiKeysQueryOptions(
  page = 1,
  limit = 50,
  sort?: unknown,
  filter?: string,
) {
  return queryOptions({
    queryKey: ['api-keys', { page, limit, sort, filter }],
    queryFn: () => fetchApiKeys(buildQs(page, limit, sort, filter)),
  });
}

export function useApiKeysList() {
  const table = useTable('api-keys', { mode: 'url' });

  const { page, limit, sort, filter } = table.queryParams;

  const { data, isLoading } = useQuery(
    apiKeysQueryOptions(
      page as number,
      limit as number,
      sort,
      filter as string | undefined,
    ),
  );

  const records = data?.data ?? [];
  const total = data?.meta?.total ?? data?.meta?.count ?? records.length;

  return { records, total, isLoading, table };
}
